<p-toast [style]="{'white-space': 'pre-wrap', width: 'auto', 'max-width': '50vw'}"
         [breakpoints]="{ '800px': { 'max-width': '100vw', right: '0', left: '0' }}"></p-toast>
<router-outlet></router-outlet>
